import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/Landing'
import Categories from '@/components/Categories'

import Cortina from '@/components/Cortina'
import Frendel from '@/components/Frendel'

import lodash from 'lodash'
import VueLodash from 'vue-lodash'

import Materials from '@/components/Materials.vue'
import MaterialsFrendel from '@/components/MaterialsFrendel.vue'

Vue.use(Router)
Vue.use(VueLodash, lodash)
function testfunction(route){
  return {
    project: route.params.level
  }
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/Categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/Cortina',
      name: 'Cortina',
      component: Cortina
    },
    {
      path: '/Cortina/:level',
      name: 'Levels',
      component: Materials,
      props: testfunction
    },
    {
      path: '/Frendel',
      name: 'Frendel',
      component:Frendel
    },
    {
      path: '/Frendel/:level',
      name: 'Levels',
      component: MaterialsFrendel,
      props: testfunction
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js